"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MLO_LEAD_GLOBAL_EXCLUDED_STATES = exports.MloLicenseStatus = exports.ReturnToPrequalificationErrorCode = void 0;
const homeState_1 = require("./origination/homeState");
/** Why Concierge Desk refused or failed to return a loan application to pre-qualification. */
var ReturnToPrequalificationErrorCode;
(function (ReturnToPrequalificationErrorCode) {
    /** The MLO cannot act on the lead or the application is not the lead's. */
    ReturnToPrequalificationErrorCode["FORBIDDEN"] = "FORBIDDEN";
    ReturnToPrequalificationErrorCode["NOT_FOUND"] = "NOT_FOUND";
    /** Re-originating a terminal application would clone stale data. */
    ReturnToPrequalificationErrorCode["APPLICATION_TERMINAL"] = "APPLICATION_TERMINAL";
    /** Partner-originated or partner-inquiry-linked applications are never re-originated from Concierge Desk. */
    ReturnToPrequalificationErrorCode["PARTNER_APPLICATION"] = "PARTNER_APPLICATION";
    /** Prequal underwriting on the re-originated application decided to deny it. */
    ReturnToPrequalificationErrorCode["APPLICATION_DENIED"] = "APPLICATION_DENIED";
    /** The re-origination threw, or prequal underwriting could not reach a decision (e.g. a data-provider failure). */
    ReturnToPrequalificationErrorCode["RE_ORIGINATION_FAILED"] = "RE_ORIGINATION_FAILED";
})(ReturnToPrequalificationErrorCode || (exports.ReturnToPrequalificationErrorCode = ReturnToPrequalificationErrorCode = {}));
/**
 * License status for a mortgage loan originator. Values are lowercase — matches DB column.
 * @TranslateToPython
 */
var MloLicenseStatus;
(function (MloLicenseStatus) {
    MloLicenseStatus["PENDING"] = "pending";
    MloLicenseStatus["ACTIVE"] = "active";
    MloLicenseStatus["INACTIVE"] = "inactive";
    MloLicenseStatus["EXPIRED"] = "expired";
})(MloLicenseStatus || (exports.MloLicenseStatus = MloLicenseStatus = {}));
/**
 * States no MLO may work a lead in, whatever licenses they hold. Mirrored into Python so bulk lead
 * loads drop these rows before upload, not only at claim/send time in MloLicenseLeadFilterService.
 * @TranslateToPython
 */
exports.MLO_LEAD_GLOBAL_EXCLUDED_STATES = [
    homeState_1.StateTwoLetterCodes.texas,
    homeState_1.StateTwoLetterCodes.southCarolina,
    homeState_1.StateTwoLetterCodes.wyoming,
    homeState_1.StateTwoLetterCodes.wisconsin,
    homeState_1.StateTwoLetterCodes.nebraska,
    homeState_1.StateTwoLetterCodes.idaho,
];
